const validations = {
  // 必須
  required(v) {
    return !!v || "必須入力項目です";
  },
  // 必須選択
  requiredSelect(v) {
    return !!v || "選択してください";
  },
  // 必須チェックボックス
  requiredCheck(v) {
    return !!v || "チェックを入れてください";
  },
  // 最大文字数
  maxLength(v, max) {
    return !v || v.length <= max || `${max}文字以内で入力をお願いします`;
  },
  // 最低文字数
  minLength(v, min) {
    return !v || v.length >= min || `${min}文字以上で入力をお願いします`;
  },
  KanjiHiraKata(v) {
    return (
      !v ||
      /^[ぁ-んァ-ヶ一-﨑龠々ー]*$/.test(v) ||
      "全角の漢字・ひらがな・カタカナで入力をお願いします"
    );
  },
  fullWithKata(v) {
    return (
      !v ||
      /^[ァ-ヶー 　]*$/.test(v) ||
      "全角のカタカナで入力をお願いします"
    );
  },
  HalfWidth(v) {
    return !v || /^[\u0000-\u00FF]*$/.test(v) || "半角文字で入力をお願いします";
  },
  Login(v) {
    return !v || /^[a-zA-Z0-9_.]*$/.test(v) || "半角文字で入力をお願いします";
  },
  halfWidthNumber(v) {
    return !v || /^[0-9]*$/.test(v) || "半角数字のみで入力をお願いします";
  },
  email(v) {
    // 参考したソース https://www.w3resource.com/javascript/form/email-validation.php
    return (
      !v ||
      /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
        v
      ) ||
      "正しいメールアドレスの形式で入力をお願いします"
    );
  },
  zipcodePart1(v) {
    return !v || /^[0-9]{3}$/.test(v) || "3桁の半角数字で入力をお願いします";
  },
  zipcodePart2(v) {
    return !v || /^[0-9]{4}$/.test(v) || "4桁の半角数字で入力をお願いします";
  },
  zipcodePart1AndPart2(part1, part2) {
    return (!part1 && !part2) || (/^[0-9]{3}$/.test(part1) && /^[0-9]{4}$/.test(part2)) || "3-4桁の半角数字で入力をお願いします";
  },
  tel(v) {
    return (
      !v || /^[0-9]{10,11}$/.test(v) || "正しい数字・桁数（ハイフン「-」なし）で入力をお願いします"
    );
  },
  url(v) {
    // 参考したソース https://gist.github.com/dperini/729294
    var pattern = new RegExp(
      "^(?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+(?:[a-z\\u00a1-\\uffff]{2,}\\.?))(?::\\d{2,5})?(?:[/?#]\\S*)?$",
      "i"
    );
    return !v || pattern.test(v) || "正しいURLの形式で入力をお願いします（http://、https://からご入力ください。）";
  },
  password(v) {
    return (
      !v ||
      new RegExp(
        "^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d!\"#$%&'()*+,-./:;<=>?@\\[\\]^_`{|}~]{8,16}$",
        ""
      ).test(v) ||
      "半角英字（大文字）、半角英字（小文字）、数字がそれぞれ1文字以上入っている8～16文字の文字列で入力をお願いします"
    );
  },
  FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v) {
    return (
      !v ||
      /^[ぁ-んァ-ヶ一-﨑龠々ー０-９ａ-ｚＡ-Ｚ\u2160-\u21880-9a-z A-Z･ｦ-ﾟ 　‐－ー―−、，（）＆‘’“”‛´‵`"〝‟．：・’]*$/.test(v) ||
      "全角文字・半角英数字で入力をお願いします"
    );
  },
  fullWidthAndHalfAlphabetAndSpecialSymbols(v) {
    return (
      !v ||
      /^[ぁ-んァ-ヶ一-﨑龠々ー０-９ａ-ｚＡ-Ｚ 　0-9a-zA-Z\u2160-\u2188-_@*/、。，．・：；？！゛゜´｀¨＾￣＿‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－≠＜＞°′″℃￥＄￠￡％＃＆＊＠※〒、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓♯♭♪｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳≒＝≠≦≧㊨㈱㈲㈹㍾㍽㍼㍻㊤㊥㊦㊧∑∩]*$/.test(
        v
      ) ||
      "全角文字・半角英数字・一部記号で入力をお願いします"
    );
  },
  fullWidth(v) {
    return (
      !v ||
      /^[ぁ-んァ-ヶ一-﨑龠々ー　０-９ａ-ｚＡ-Ｚ\u2160-\u2188―‐−、。，．・：；？！゛゜´｀¨＾￣＿‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－≠＜＞°′″℃￥＄￠￡％＃＆＊＠※〒]*$/.test(
        v
      ) ||
      "全角文字で入力をお願いします"
    );
  },
  HalfAlphabetAndSpace(v) {
    return (
      !v ||
      /^[a-z A-Z]*$/.test(v) ||
      "半角英字のみで入力をお願いします"
    );
  },
  halfAlphabetAndNumber(v) {
    return (
      !v ||
      /^[a-zA-Z0-9]*$/.test(v) ||
      "半角英数字のみで入力をお願いします"
    );
  },
};

export default validations;
